const sortCinemas = (cinemaId, cinemas, cinemasFilter = null) => {
    if(!cinemaId || !cinemas) return []
    
    let sortedCinemas
    const cinemaData = cinemas[cinemaId]

    if(cinemas[cinemaId]) {
        if(cinemasFilter) {
            sortedCinemas = cinemasFilter.sort(function(a, b) {
                const aCinema = cinemas[a].nameShort
                const bCinema = cinemas[b].nameShort 
                
                return bCinema > aCinema ? -1 : bCinema < aCinema ? 1 : 0
            })
        } else {
            const currentType = cinemaData.scope.type
            
            if(currentType === 'multi') {
                sortedCinemas = cinemaData.scope.cinemas.sort(function(a, b) {
                    const aCinema = cinemas[a].nameShort
                    const bCinema = cinemas[b].nameShort 
                    
                    return bCinema > aCinema ? -1 : bCinema < aCinema ? 1 : 0
                })
            }  else if(currentType === 'single') {
                return [cinemaId]
            }      
        }
    }

    return sortedCinemas
}

export default sortCinemas